import "./PaymentPageView.scss";
import { Row } from "antd";
import { useRecoilState } from "recoil";
import { paymentPageDetail, paymentPageInitResponse } from "../../store/store";
import { Navigate, useParams } from "react-router-dom";
import { getPageDetailApi } from "../../api/paymentPage";
import PaymentPageLoaded from "./PaymentPageLoaded";
import PaymentPageLoading from "./PaymentPageLoading";
import { useQuery } from "react-query";
import { IPaymentPageDetail } from "@app-models";
import { useEffect } from "react";
import MerchantLeftPanel from "./components/MerchantLeftPanel";
import PaymentPageFooter from "./components/PaymentPageFooter";
import { MONNIFY_LOADING_LOGO_URL, MONIEPOINT_LOADING_LOGO_URL } from "./constants";

const PaymentPageView = () => {
  const [, setPageDetail] = useRecoilState(paymentPageDetail);
  const params = useParams<{ code: string | undefined }>();

  const [pageInitValue, setPageInitResponse] = useRecoilState(paymentPageInitResponse);

  const { isLoading, data, error } = useQuery({
    queryKey: ["payment-page-detail", params.code],
    queryFn: async () => {
      const response = await getPageDetailApi(params.code);
      return response.data as IPaymentPageDetail;
    },
    retry: 1,
  });

  const handleIframeLoad = () => {
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    if (data) setPageDetail(data);
  }, [data]);

  useEffect(() => {
    return () => {
      setPageInitResponse(null);
    };
  }, []);

  if (isLoading) {
    return (
      <section className="payment-page-container">
        <main className="main">
          <PaymentPageLoading />
        </main>
        <footer className="footer">
          <Row className="mb-5">
            <img src={MONNIFY_LOADING_LOGO_URL} alt="monnify" />
          </Row>
          <Row className="ml-5" align={"middle"}>
            <span className="by-text">by</span>
            <img src={MONIEPOINT_LOADING_LOGO_URL} alt="monnify" />
          </Row>
        </footer>
      </section>
    );
  }

  if (error) return <Navigate to={"/page/not-found"} />;

  return (
    <div className="payment-page-container">
      <div className="payment-page-split" style={{ position: "relative" }}>
        <div className="left-panel">
          <MerchantLeftPanel pageDetail={data} />
        </div>
        <div className="right-panel">
          <div className="right-panel-content">
            <PaymentPageLoaded />
          </div>
          <PaymentPageFooter />
        </div>
        {pageInitValue && (
          <div className="frame-container">
            <iframe
              title="Monnify checkout"
              src={pageInitValue?.checkoutUrl}
              width={"100%"}
              height={"100%"}
              onLoad={handleIframeLoad}
              id="frame-container"
              data-testid="iframe-container"
            >
              Unable to load payment methods
            </iframe>
          </div>
        )}
      </div>
    </div>
  );
};

export default PaymentPageView;
